import { motion } from 'framer-motion';
import AnimatedPage from '../components/AnimatedPage';

const TermsOfService = () => {
  return (
    <AnimatedPage>
      <div className="min-h-screen pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-1 mb-6">Terms of Service</h1>
            <div className="w-20 h-1 bg-black mb-8" />
            <p className="text-gray-600 font-body mb-8">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="space-y-8 font-body">
              <section>
                <h2 className="heading-3 mb-4">1. Agreement to Terms</h2>
                <p className="text-gray-700 leading-relaxed">
                  By accessing and using RaiBlog, you accept and agree to be bound by the terms and provision of this 
                  agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">2. Use License</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Permission is granted to temporarily access the materials (information or software) on RaiBlog's 
                  website for personal, non-commercial transitory viewing only. This is the grant of a license, not a 
                  transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or public display</li>
                  <li>Attempt to decompile or reverse engineer any software contained on RaiBlog's website</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                  <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">3. Content Ownership</h2>
                <p className="text-gray-700 leading-relaxed">
                  All content published on RaiBlog, including but not limited to text, graphics, logos, images, and 
                  software, is the property of RaiBlog or its content suppliers and is protected by international 
                  copyright laws.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">4. User Comments and Submissions</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  If you submit content to RaiBlog, you grant us a non-exclusive, royalty-free, perpetual, and worldwide 
                  license to use, reproduce, modify, and distribute your content. You represent and warrant that:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>You own or have the necessary rights to the content you submit</li>
                  <li>Your content does not violate any third-party rights</li>
                  <li>Your content does not contain any defamatory, libelous, or illegal material</li>
                </ul>
              </section>

              <section>
                <h2 className="heading-3 mb-4">5. Disclaimer</h2>
                <p className="text-gray-700 leading-relaxed">
                  The materials on RaiBlog's website are provided on an 'as is' basis. RaiBlog makes no warranties, 
                  expressed or implied, and hereby disclaims and negates all other warranties including, without 
                  limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, 
                  or non-infringement of intellectual property or other violation of rights.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">6. Limitations</h2>
                <p className="text-gray-700 leading-relaxed">
                  In no event shall RaiBlog or its suppliers be liable for any damages (including, without limitation, 
                  damages for loss of data or profit, or due to business interruption) arising out of the use or inability 
                  to use the materials on RaiBlog's website.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">7. Accuracy of Materials</h2>
                <p className="text-gray-700 leading-relaxed">
                  The materials appearing on RaiBlog's website could include technical, typographical, or photographic 
                  errors. RaiBlog does not warrant that any of the materials on its website are accurate, complete, or 
                  current.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">8. Links</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog has not reviewed all of the sites linked to its website and is not responsible for the contents 
                  of any such linked site. The inclusion of any link does not imply endorsement by RaiBlog of the site. 
                  Use of any such linked website is at the user's own risk.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">9. Advertisements</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog may display third-party advertisements on its website. We are not responsible for the content 
                  of these advertisements or the products/services offered by advertisers.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">10. Modifications</h2>
                <p className="text-gray-700 leading-relaxed">
                  RaiBlog may revise these terms of service at any time without notice. By using this website, you are 
                  agreeing to be bound by the then-current version of these terms of service.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">11. Governing Law</h2>
                <p className="text-gray-700 leading-relaxed">
                  These terms and conditions are governed by and construed in accordance with the laws and you 
                  irrevocably submit to the exclusive jurisdiction of the courts in that location.
                </p>
              </section>

              <section>
                <h2 className="heading-3 mb-4">Contact Information</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions about these Terms of Service, please contact us through our{' '}
                  <a href="/contact" className="text-black underline hover:no-underline">Contact page</a>.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default TermsOfService;
